<template>
    <CSmartPagination
        class="mt-3"
        @active-page-change="updateActivePage"
    />
</template>

<script setup>
import { CSmartPagination } from '@coreui/vue-pro'

const emit = defineEmits(['update:activePage'])

const updateActivePage = (page) => {
    emit('update:activePage', page)
}
</script>

<style lang="scss">
.pagination {
    * {
        line-height: var(--cui-body-line-height);
        font-size: 14px;
    }

    & .page-item:hover {
        cursor: pointer
    }

    & .disabled:hover {
        cursor: auto;
    }
}

</style>
